
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instructors/scheduling/my-lessons",
      function () {
        return require("private-next-pages/instructors/scheduling/my-lessons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instructors/scheduling/my-lessons"])
      });
    }
  